// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2M6du","content":"LoadingAlert_content__1w_FN"};